const state = {
  userName: '',
  userID: '',
  userType: [],
  userCompanyDocId: '',
  userRoleList: [],
}

const actions = {
  updateUserName({ commit }, payload) {
    commit('updateName', payload)
  },
  updateUserID({ commit }, payload) {
    commit('updateID', payload)
  },
  updateUserType({ commit }, payload) {
    commit('updateType', payload)
  },
  updateUserCompanyDocId({ commit }, payload) {
    commit('updateCompanyDocId', payload)
  },
  updateUserRoleList({ commit }, payload) {
    commit('updateRoleList', payload)
  }
}

const getters = {
  getUserName: state => {
    return state.userName
  },
  getUserID: state => {
    return state.userID
  },
  getUserType: state => {
    return state.userType
  },
  getUserCompanyDocId: state => {
    return state.userCompanyDocId
  },
  getUserRoleList: state => {
    return state.userRoleList
  },
}

const mutations = {
  updateName: (state, payload) => {
    state.userName = payload.userName
  },
  updateID: (state, payload) => {
    state.userID = payload.userID;
  },
  updateType: (state, payload) => {
    state.userType = payload.userType;
  },
  updateCompanyDocId: (state, payload) => {
    state.userCompanyDocId = payload.userCompanyDocId;
  },
  updateRoleList: (state, payload) => {
    state.userRoleList = payload.userRoleList;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}